<script>
import apiServices from '@/services/yungol-services'
const XLSX = require("xlsx");
export default {
  template: `<div class="buttons is-justify-end" style='width: 100%; height: 100%; margin: auto;'>
  <button class="button is-danger" v-on:click="deleteRelation()">
      <span v-tooltip="'Eliminar'" class="icon">
        <i class="material-icons">delete_forever</i>
      </span>
  </button>
  <button class="button is-dark" :disabled="isCalculado" v-on:click="sendEmail()">
      <span v-tooltip="isCalculado ? 'Encuesta ya calculada' : 'Enviar Correo'" class="icon">
        <i class="material-icons">email</i>
      </span>
  </button>
  <button class="button is-link" v-on:click="downloadResponses()">
      <span v-tooltip="'Descargar Respuestas'" class="icon">
        <i class="material-icons">cloud_download</i>
      </span>
  </button>
  <button class="button is-link" v-on:click='linkSurvey()'>
      <span v-tooltip="'Link Encuesta'" class="icon">
        <i class="material-icons">share</i>
      </span>
  </button>
  </div>`,
  data(){
    return {
      isCalculado: false,
    }
  },
  beforeMount() {
    if (this.params.data.status === 'calculado') {
      this.isCalculado = true
    }
  },
  methods:{
    // Actions
    async deleteRelation(){
      const config = {
        title: '¿Estás seguro?',
        text: "Al eliminar no se podrá recuperar la relación después",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#de5b5b',
        confirmButtonText: 'Sí, eliminar'
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const result = await apiServices.delete(`/relacion/${this.params.value}`);
            if (result.data) {
              await this.$swal({
                text: 'Relación eliminada correctamente.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1700
              })
              this.params.api.applyTransaction({
                remove: [this.params.node.data],
              });
            }
          } catch (err) {
            await this.$swal({
              text: 'Error al eliminar la relación.',
              icon: 'error',
              showConfirmButton: false,
              timer: 1700
            })
            console.log(err)
          }
        }
      });
    },
    async sendEmail() {
      if (this.params.data.status === 'calculado') return;
      let result;
      const d = {
        id: this.params.value,
      };
      try {
        result = await apiServices.post(`/enviarcorreo`, d);
        // this.datafile = result.data;
        if (result.data) {
          await this.$store.dispatch("notify", {
            message: "Correo enviado exitosamente.",
          });
        }
        await this.params.getRelations();
      } catch (error) {
        await this.$store.dispatch("notify", {
          message: "Error al enviar el correo.",
          type: "is-danger",
          duration: 4000,
          position: "top-right",
        });
        console.log(error);
      }
    },
    async downloadResponses() {
      const d = [this.params.data.responses, this.params.data.evaluador.nombre]

      if (d[0]) {
        this.dataToExport = [];
        this.dataToExport.push(d[0]);

        // Se parsea el valor boolean a texto
        this.dataToExport[0].agree ? this.dataToExport[0].agree = "Si" : this.dataToExport[0].agree = "No"

        //  Asignamos la información necesaria a nuevas variables
        let name = "LD-Respuestas " + d[1];
        //  Se agrega la data al libro de excel
        const ws = XLSX.utils.json_to_sheet(this.dataToExport);

        //  Se configura el tamaño de cada columna
        ws["!cols"] = this.params.widthCols(this.dataToExport)

        //  Se crea el libro con la data agregada, se le da un nombre y finalizando se descarga
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Respuestas");
        const nombreArchivo = name + ".xlsx";
        XLSX.writeFile(wb, nombreArchivo);

      } else {
        await this.$store.dispatch("notify", {
          message: `Este Usuario no tiene respuestas`,
          type: "is-danger",
        });
      }
    },
    linkSurvey() {
      const url = window.location.host + '/encuesta/' + this.params.value

      const textArea = document.createElement('textarea')
      textArea.style.position = 'fixed'
      textArea.style.top = 0
      textArea.style.left = 0
      textArea.style.width = '2em'
      textArea.style.height = '2em'
      textArea.style.padding = 0
      textArea.style.border = 'none'
      textArea.style.outline = 'none'
      textArea.style.boxShadow = 'none'
      textArea.style.background = 'transparent'
      textArea.value = url

      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        const successful = document.execCommand('copy')
        this.$store.dispatch('notify', {
          message: successful ? '¡Copiado al portapapeles!' : 'Error al copiar',
          type: successful ? 'is-link' : 'is-danger'
        })
      } catch (err) {
        console.log(err)
      }

      document.body.removeChild(textArea)
    },
  }
}
</script>

<style lang='scss'>
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/components/buttonsActionRelation.vue